import apiClient from "./apiClient";

export const getRiskMatrixConfig = () => apiClient.get("/risk-matrix-config");
export const updateRiskMatrixConfig = (payload) => apiClient.put("/risk-matrix-config", payload);
